import React, { FC } from 'react';

import { Icon } from 'common/components';
import { EntityActions } from 'common/enums';
import { ICON_COLLECTION } from 'assets/media/icons';

import './ArchiveCellRenderer.scss';

type ArchiveCellRendererProps = {
    data: any;
    isRestoreActionDisabled: boolean;
    isDeleteActionDisabled: boolean;
    onAction: (action: string, data: any) => any;
};

const ArchiveCellRenderer: FC<ArchiveCellRendererProps> = ({
    data,
    isRestoreActionDisabled = false,
    isDeleteActionDisabled = false,
    onAction
}: ArchiveCellRendererProps) => {
    return (
        <div className="archive-cell">
            <span
                className={
                    isRestoreActionDisabled
                        ? 'archive-icon-container-disabled'
                        : 'archive-icon-container'
                }
                onClick={() =>
                    isRestoreActionDisabled ? '' : onAction(EntityActions.Restore, data)
                }>
                <Icon
                    className="archive-icon restore"
                    src={ICON_COLLECTION.IC_Restore}
                    title="Restore"
                />
            </span>
            <span
                className={
                    isDeleteActionDisabled
                        ? 'archive-icon-container-disabled'
                        : 'archive-icon-container'
                }
                title="Edit"
                onClick={() =>
                    isDeleteActionDisabled ? '' : onAction(EntityActions.Delete, data)
                }>
                <Icon
                    className="archive-icon delete"
                    src={ICON_COLLECTION.IC_Delete}
                    title="Delete"
                />
            </span>
        </div>
    );
};
export default ArchiveCellRenderer;
